var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileVideoAdLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.954 6.016c0-.715-.683-1.405-1.208-1.405h-3.28c.262-.22.412-.834.647-2.138.013-.072-.016-1.134-.022-1.171C8.991.635 8.8.295 8.343.112c-.636-.254-1.85-.065-1.827.453.022.488.232 1.909.088 2.392-.169.57-.521.804-.846 1.203C5.366 4.64 4.022 5.64 4 5.64v6.326s6.157.066 6.52 0c.364.066 1.347.017 1.394-.693 0-.71-.57-1.067-.57-1.067s.863-.007.863-.704-.257-.925-.257-.925.674.151.674-.62c0-.355-.189-.577-.594-.575.263 0 .924-.356.924-1.366M0 12.936h3.292v-6.87H.05z"
})));
export default SvgFacebookMobileVideoAdLike;